import React from 'react';
import { FlowType, FlowTypeInfo } from '../../../../../types/flow';
import { cn } from '../lib/utils';

interface FlowTypeSelectorProps {
  flowTypes: FlowTypeInfo[];
  selectedType: FlowType;
  onSelectType: (type: FlowType) => void;
}

const typeColorMap: Record<FlowType, string> = {
  pre: 'flow-chip-pre',
  post: 'flow-chip-post',
  country: 'flow-chip-country',
  vpn: 'flow-chip-vpn',
  base: 'flow-chip-base',
  adslot: 'flow-chip-adslot',
};

export const FlowTypeSelector: React.FC<FlowTypeSelectorProps> = ({
  flowTypes,
  selectedType,
  onSelectType,
}) => {
  return (
    <div className="adslot-sidebar-section adslot-sidebar-section-border">
      <h3 className="adslot-sidebar-section-title">Flow Types</h3>
      <div className="adslot-sidebar-type-list">
        {flowTypes.map(flowType => (
          <button
            key={flowType.type}
            type="button"
            onClick={() => onSelectType(flowType.type)}
            className={cn(
              'adslot-sidebar-type-card',
              typeColorMap[flowType.type],
              selectedType === flowType.type &&
                'adslot-sidebar-type-card-selected',
            )}
          >
            <div className="adslot-sidebar-type-card-inner">
              <span className="adslot-sidebar-type-icon">{flowType.icon}</span>
              <div className="adslot-sidebar-type-text">
                <div className="adslot-sidebar-type-label">
                  {flowType.label}
                </div>
                <div className="adslot-sidebar-type-meta">
                  {flowType.count} flows
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
